import { put, select, takeLatest } from 'redux-saga/effects';
//@ts-ignore
import { getWizardHints } from 'yandex-dumbledore/dist/index';

//@ts-ignore
import { REPLACE_ROUTE_IN_TREE, ADD_ROUTE_TO_TREE } from '../router/constants.ts';
//@ts-ignore
import { getWizard } from '../user/selectors';

import { setMatchedHints } from './actions';
import { SET_CONFIG, ADD_VIEWED_HINT_SUCCESS } from './constants';
import { getConfig } from './selectors';

function* processConfigSaga() {
    const config: unknown = yield select(getConfig);
    const wizard: unknown = yield select(getWizard);

    if (!config) {
        return;
    }

    const hints = getWizardHints(config, wizard);

    yield put(setMatchedHints(hints));
}

export function* processConfigWatcher() {
    yield takeLatest(
        [ADD_VIEWED_HINT_SUCCESS, REPLACE_ROUTE_IN_TREE, ADD_ROUTE_TO_TREE, SET_CONFIG],
        processConfigSaga
    );
}

export const wizardWatchers = [processConfigWatcher()];
